import { render, staticRenderFns } from "./GiftManage.vue?vue&type=template&id=35cadae2&scoped=true"
import script from "./GiftManage.vue?vue&type=script&lang=js"
export * from "./GiftManage.vue?vue&type=script&lang=js"
import style0 from "./GiftManage.vue?vue&type=style&index=0&id=35cadae2&scoped=true&lang=scss"
import style1 from "./GiftManage.vue?vue&type=style&index=1&id=35cadae2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cadae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cadae2')) {
      api.createRecord('35cadae2', component.options)
    } else {
      api.reload('35cadae2', component.options)
    }
    module.hot.accept("./GiftManage.vue?vue&type=template&id=35cadae2&scoped=true", function () {
      api.rerender('35cadae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/GiftManage.vue"
export default component.exports